// extracted by mini-css-extract-plugin
export default {"wrapper":"playlists_wrapper__CEm+k","content":"playlists_content__QaPJw","loader":"playlists_loader__T+s1n"};